import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://memdufxubnwfvczzkzrj.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1lbWR1Znh1Ym53ZnZjenprenJqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc2ODE5MzQsImV4cCI6MjA5MzI1NzkzNH0.nf4Fe1wYJcOOMXCqG1Zgibd-IJjcOSprLw-B_8JlmIY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Header de Authorization con el token de sesión activa, para endpoints de
// /api/* que ahora requieren sesión válida (ver api/_verificarAdmin.js /
// verificarSesion). Si no hay sesión, se manda vacío y el server responde 401.
export async function authHeader() {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.access_token ? { Authorization: 'Bearer ' + session.access_token } : {};
}
